<template>
  <div class="cf-takeover">
    <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--justify-center cf-flex--gap-12 cf-text-align-center cf-padding-16">
      <span class="cf-icon cf-icon--large cf-icon--red far fa-exclamation-triangle" />

      <h1 class="cf-title cf-title--1 cf-title--red">
        {{ fullPageMessage.title }}
      </h1>

      <h3
        v-if="fullPageMessage.subtitle"
        class="cf-title cf-title--3"
      >
        {{ fullPageMessage.subtitle }}
      </h3>

      <p
        v-if="fullPageMessage.description"
        class="cf-subtitle cf-subtitle--1"
      >
        {{ fullPageMessage.description }}
      </p>
    </div>

    <button
      v-if="fullPageMessage.button.show"
      type="button"
      :class="['cf-button cf-button--primary cf-button--lg', { 'cf-button--loading': fullPageMessage.button.isProcessing }]"
      @click="fullPageMessage.button.action"
    >
      {{ fullPageMessage.button.text }}
    </button>

    <cf-reset-table-button />
  </div>
</template>


<script>
  import CfResetTableButton from '@/view/components/globals/cf-reset-table-button/index.vue';


  export default {
    name: 'TakeoverMessagePage',

    components: {
      CfResetTableButton
    },

    props: {
      fullPageMessage: {
        type: Object,
        required: true
      }
    }
  };
</script>
